<template>
    <div>
        <sau-template :retrieved="gotData">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Domain Details</template>

            <!-- Data -->
            <template slot="data">
                <div class="row">
                    <div class="col pb-6">
                        <div class="flex items-center mb-1">
                            <h3 class="flex-1 mb-0">Details</h3>
                            <div>
                                <!-- If can renew. -->
                                <a  v-if="isRenewable"
                                    :href="`/order/create?domain-renewal=${domain.id}`"
                                    class="ml-5 no-underline text-blue-500 hover:text-blue-600"
                                >
                                    <i class="far fa-shopping-cart text-grey-900 mr-1"></i>
                                    Renew Domain
                                </a>
                                <a  v-if="canUpdateDomain && !locked"
                                    :href="domainContactsLink"
                                    class="ml-5 no-underline text-blue-500 hover:text-blue-600"
                                >
                                    <i class="far fa-user-edit text-grey-900 mr-1"></i>
                                    Update Contacts
                                </a>
                            </div>
                        </div>
                        <div class="sau-bx bx-pad">
                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <ul class="sau-list-display">
                                        <li v-if="details.status">
                                            <h5>Registry Status</h5>
                                            <p>{{ details.status }}</p>
                                        </li>
                                        <li v-if="details.registrant.name">
                                            <h5>Registrant Contact Name</h5>
                                            <p>{{ details.registrant.name }}</p>
                                        </li>
                                        <li v-if="details.tech.name">
                                            <h5>Tech Contact Name</h5>
                                            <p>{{ details.tech.name }}</p>
                                        </li>
                                        <li v-if="details.admin.name">
                                            <h5>Admin Contact Name</h5>
                                            <p>{{ details.admin.name }}</p>
                                        </li>
                                        <li v-if="details.billing.name">
                                            <h5>Billing Contact Name</h5>
                                            <p>{{ details.billing.name }}</p>
                                        </li>
                                        <li v-if="details.lock">
                                            <h5>Registrar Lock</h5>
                                            <p>{{ details.lock }}</p>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-sm-12 col-md-6">
                                    <ul class="sau-list-display">
                                        <li v-if="details.expiry">
                                            <h5>Expiry</h5>
                                            <p>{{ details.expiry | moment('DD/MM/YYYY') }}</p>
                                        </li>
                                        <li v-if="details.registrant.email">
                                            <h5>Registrant Email</h5>
                                            <p>{{ details.registrant.email }}</p>
                                        </li>
                                        <li v-if="details.tech.email">
                                            <h5>Tech Email</h5>
                                            <p>{{ details.tech.email }}</p>
                                        </li>
                                        <li v-if="details.admin.email">
                                            <h5>Admin Email</h5>
                                            <p>{{ details.admin.email }}</p>
                                        </li>
                                        <li v-if="details.billing.email">
                                            <h5>Billing Email</h5>
                                            <p>{{ details.billing.email }}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="locked">
                    <div class="col pb-6">
                        <sau-apiro-response type="message">
                            <template slot="message">Unable to update contacts.</template>
                            <template slot="details">
                                <p>{{ locked }}</p>
                            </template>
                        </sau-apiro-response>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="flex items-center mb-1">
                            <h3 class="flex-1 mb-0">Nameservers</h3>
                            <div>
                                <a  v-if="canUpdateDomain && Object.keys(filteredNameservers).length > 0"
                                    :href="domainNameserversLink"
                                    class="ml-5 no-underline text-blue-500 hover:text-blue-600"
                                >
                                    <i class="far fa-edit text-grey-900 mr-1"></i>
                                    Update Nameservers
                                </a>
                            </div>
                        </div>
                        <div
                            class="sau-bx bx-pad text-center"
                            v-if="Object.keys(filteredNameservers).length > 0"
                        >
                            <div class="row">
                                <div class="col-lg-6">
                                    <ul class="sau-list-display">
                                        <li
                                            v-for="(ns, index) in nameserversFirstColumn"
                                            :key="index"
                                        >
                                            <h5>{{ ns }}</h5>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-lg-6">
                                    <ul class="sau-list-display">
                                        <li
                                            v-for="(ns, index) in nameserversSecondColumn"
                                            :key="index"
                                        >
                                            <h5>{{ ns }}</h5>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <sau-apiro-response type="error" support="true">
                                <template
                                    slot="message"
                                >There was an issue retrieving your nameservers.</template>
                                <template slot="details">
                                    <p>If you would like further details please contact our Support Team.</p>
                                </template>
                            </sau-apiro-response>
                        </div>
                    </div>
                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
export default {
    props: {
        domain: Object,
        isRenewable: Boolean,
    },
    data() {
        return {
            details: {
                registrant: [],
                tech: [],
                admin: [],
                billing: []
            },
            nameservers: [],
            whois: '',
            locked: ''
        };
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getDomainDetails()
                .then(response => {
                    if (response.data.nameservers) {
                        this.nameservers = response.data.nameservers;
                        this.whois = response.data.whois;
                        this.formatDetails();
                    }
                })
                .catch(error => {});
        },
        formatDetails() {
            // only show selected fields from the domain object
            this.details.lock = this.domain.lock;
            this.details.status = this.domain.status;
            this.details.expiry = this.domain.expirydate;

            // filter out registrant contact name + Email & Tech contact name + email

            /** Comes in different formats
             * FirstName
             * first_name
             *
             * maybe return anything with first in fieldname
             */

            if (!this.contactsLocked()) {
                this.details.registrant.name =
                    this.findField(this.whois.data.Registrant, 'first') +
                    ' ' +
                    this.findField(this.whois.data.Registrant, 'last');
                this.details.registrant.email = this.findField(
                    this.whois.data.Registrant,
                    'email'
                );
                this.details.tech.name =
                    this.findField(this.whois.data.Tech, 'first') +
                    ' ' +
                    this.findField(this.whois.data.Tech, 'last');
                this.details.tech.email = this.findField(
                    this.whois.data.Tech,
                    'email'
                );
                this.details.admin.name =
                    this.findField(this.whois.data.Admin, 'first') +
                    ' ' +
                    this.findField(this.whois.data.Admin, 'last');
                this.details.admin.email = this.findField(
                    this.whois.data.Admin,
                    'email'
                );
                this.details.billing.name =
                    this.findField(this.whois.data.Billing, 'first') +
                    ' ' +
                    this.findField(this.whois.data.Billing, 'last');
                this.details.billing.email = this.findField(
                    this.whois.data.Billing,
                    'email'
                );

                // Check that the result isn't an empty string - if so remove the entry so it doesn't display in the loop
                this.details.registrant.name =
                    this.details.registrant.name == ' '
                        ? ''
                        : this.details.registrant.name;
                this.details.billing.name =
                    this.details.billing.name == ' '
                        ? ''
                        : this.details.billing.name;
                this.details.admin.name =
                    this.details.admin.name == ' '
                        ? ''
                        : this.details.admin.name;
                this.details.tech.name =
                    this.details.tech.name == ' ' ? '' : this.details.tech.name;
            }
        },
        findField(collection, field) {
            let result = _.find(collection, function(val, key) {
                return key.toLowerCase().includes(field);
            });
            return result == undefined ? '' : result;
        },
        contactsLocked() {
            // Check whois.data.error
            if (this.whois.data.error) {
                this.locked = this.whois.data.error;
                return true;
            }
            return false;
        }
    },
    computed: {
        filteredNameservers() {
            return _.filter(this.nameservers, function(val, key) {
                // Filter out any blank values and non nameserver entries (like dnsConfigType)
                return val && key.toLowerCase().substring(0, 2) == 'ns';
            });
        },
        nameserversFirstColumn() {
            return this.filteredNameservers.slice(
                0,
                this.filteredNameservers.length / 2
            );
        },
        nameserversSecondColumn() {
            return this.filteredNameservers.slice(
                this.filteredNameservers.length / 2 + 1
            );
        }
    }
};
</script>
